import cx from 'classnames';
import { FieldName } from '~/components/giveaway/constants';
import CheckFilled from '~/icons/CheckFilled';
import { Container, IconContainer, Input, Label } from './FormField.styles';

type OwnProps = {
  fieldName: FieldName;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isSubmitted: boolean;
  isValid: boolean;
};

const FormField = ({
  fieldName,
  handleChange,
  isSubmitted,
  isValid
}: OwnProps) => {
  const fieldId = `giveaway-${fieldName.split(' ').join('-')}`;

  return (
    <Container>
      <div className="relative flex h-full w-full">
        <Input
          className={cx({ 'bg-white opacity-50': isSubmitted })}
          data-qa={fieldId}
          disabled={isSubmitted}
          id={fieldId}
          onChange={handleChange}
          placeholder={fieldName}
        />
        <Label
          className={cx({ 'bg-white opacity-50': isSubmitted })}
          htmlFor={fieldId}
        >
          {fieldName}
        </Label>
      </div>
      <IconContainer>
        {isValid && (
          <CheckFilled
            className={cx(
              'h-16 w-16 rounded-full border border-green-2 bg-green-2 text-white',
              {
                'opacity-50': isSubmitted
              }
            )}
          />
        )}
      </IconContainer>
    </Container>
  );
};

export default FormField;
